import { createRoutine } from 'redux-saga-routines';

export const fetchInventoryLocationZones = createRoutine(
  'FETCH_INVENTORY_LOCATION_ZONES'
);
export const createInventoryLocationZone = createRoutine(
  'CREATE_INVENTORY_LOCATION_ZONE'
);
export const updateInventoryLocationZone = createRoutine(
  'UPDATE_INVENTORY_LOCATION_ZONE'
);
export const deleteInventoryLocationZone = createRoutine(
  'DELETE_INVENTORY_LOCATION_ZONE'
);
